import { useEffect, useRef, useState } from "react";
import React from "react";
import p_nav_previous from "../../Assets/Images/p_nav_previous.svg";
import ion_cart_outline from "../../Assets/Images/ion_cart-outline.svg";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axiosInstance from "../../Services/axios";
import "bootstrap/dist/css/bootstrap.min.css";
import defaultimg from "../../Assets/Images/default-placeholder.png";
import { toast } from "react-toastify";
// Menu
import vegIcon from "../../Assets/Images/vegpngoutput.png"
import eggIcon from "../../Assets/Images/eggpngoutput.png"
import nonvegIcon from "../../Assets/Images/nomvegoutput.png"

// Addon 
import Skeleton from "react-loading-skeleton";

import { CgClose } from "react-icons/cg";
import { FaRegSquare, FaSquareCheck } from "react-icons/fa6";
import SelectShippingOffCanvas from "../../Components/offCanvas/selectShippingOffCanvas";
import { addOrRemoveProductCart, getProductDetails } from "../../Services/api";
import { showToast } from "../../Components/toastConfig/ToastConfig";


const SingleProduct = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { flowtype, flow, orderType } = location.state || {};




  const [product, setProduct] = useState('');
  const [cartId, setCartId] = useState("");
  const [shipingtype, setShipingtype] = useState("");
  const [cardStatus, setCardStatus] = useState();
  const [cardType, setcardType] = useState();
  const [cardId, setcardId] = useState();
  const [cartCount, setCartCount] = useState()
  const { vendorId, productid } = useParams();

  const [selectItem, setSelectItem] = useState('')
  const addonModalRef = useRef(null);
  const addonEditeModalRef = useRef(null);


  const [product_Id, setProduct_Id] = useState('')
  const [productCost, setProductCost] = useState('')
  const [addonsCost, setAddonsCost] = useState('')
  const [selectedAddons, setSelectedAddons] = useState([])
  const [productCount, setProductCount] = useState(0)
  const [addonModel, setAddonModel] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [pageLoaded, setPageLoaded] = useState(false)
  const flowtypeValue = flowtype == "EDIT_ORDER" ? "EDIT_ORDER" : flowtype;
  const [showModel, setShowModel] = useState(false)


  const toggleOffCanvas = () => {
    setShowModel(!showModel)
  }


  useEffect(() => {
    getproductdetails();
  }, [cartId]);

  useEffect(() => {
    let productCart = localStorage.getItem("productCart")
      ? JSON.parse(localStorage.getItem("productCart"))
      : "";
    setCartId(productCart?.cartId ? productCart?.cartId : "");
    setShipingtype(
      productCart?.shipping_type ? productCart?.shipping_type : ""
    );

    let appliedCard = JSON.parse(localStorage.getItem("appliedCard"));
    setCardStatus(appliedCard?.cardStatus ? appliedCard?.cardStatus : "");
    setcardType(appliedCard?.cardType ? appliedCard?.cardType : "");
    setcardId(appliedCard?.cardId ? appliedCard?.cardId : "");
  }, []);


  const getproductdetails = async () => {
    try {
      let appliedCard = JSON.parse(localStorage.getItem("appliedCard"));

      let reqData = {
        vendor_id: vendorId,
        product_id: productid,
        cart_id: cartId,
        card_type: appliedCard?.cardType,
        card_status: appliedCard?.cardStatus,
        card_id: appliedCard?.cardId,
      };


      let res = await getProductDetails(reqData);
      if (res?.status == 200) {
        setProduct(res?.data?.result);
        setSelectItem(res?.data?.result)
        setCartCount(res?.data?.cart_count)
        setProduct_Id(res?.data?.product_id)
        setTimeout(() => {
          setPageLoaded(true)
        }, 1000);
      }
    } catch (err) {
      if (err.response?.status == 400 || err.response?.status == 500) {
        showToast(err.response.data.message || "Something went wrong. Please try again.");
      }
    }
  };

  const Add_Remove_productcount = async (productId, Operation) => {

    try {
      const Addition = [];

      if (selectedAddons && selectedAddons.length > 0) {
        selectedAddons?.forEach((addon) => {
          Addition.push(...addon.options);
        });
      }

      let reqData = {
        vendor_id: vendorId,
        product_id: productId,
        shipping_type: shipingtype,
        quantity: 1,
        operation: Operation,
        cart_id: cartId,
        card_status: cardStatus,
        card_type: cardType,
        card_id: cardId,
        addons: Addition
      };


      let res = await addOrRemoveProductCart(reqData);

      if (res.status == 200) {
        const cartItemsFromAPI = res?.data?.cart_items || [];

        const updatedCartItems = cartItemsFromAPI.map(item => ({
          ...item,
          price: productCost,
        }));
        const cart_items = {
          cart_items: updatedCartItems,
          cart_id: res?.data?.cart_id,
          cart_count: updatedCartItems.length,
          sub_total: res?.data?.sub_total,
        };
        localStorage.setItem("cart_items", JSON.stringify(cart_items));


        getproductdetails()
        const localcartid = res.data.cart_id;

        let productCart = {
          shipping_type: shipingtype,
          cartId: res.data.cart_id,
          vendorId: vendorId,
        };

        localStorage.setItem("productCart", JSON.stringify(productCart));
        localStorage.setItem("cartid", JSON.stringify(res.data.cart_id));
        setCartId(res.data.cart_id);


      }

    } catch (err) {
      if (err.response?.status == 400 || err.response?.status == 500) {
        showToast(err.response.data.message || "Something went wrong. Please try again.");
      }
    }
  };


  const openAddonModal = () => {
    addonModalRef.current.classList.add("show");
    addonModalRef.current.style.display = "block";
    setProductCost(product?.price)
    setIsModalOpen(true)
  };

  const closeAddonModal = () => {
    addonModalRef.current.classList.remove("show");
    addonModalRef.current.style.display = "none";
    setIsModalOpen(false)
  };
  const handelEdittoAddonmodel = () => {
    closeEditAddonModal()
    openAddonModal()
  }
  const transformDataAndCalculateTotalCost = (rawData, selectedOptions) => {
    let transformedData = [];
    let totalCost = 0;

    if (rawData && rawData.length > 0) {
      rawData.forEach((addon) => {
        let addonObj = {
          addonId: addon.id,
          options: []
        };

        addon.options.forEach((option) => {
          if ((selectedOptions || []).some((id) => Number(id) === Number(option.id))) {
            addonObj.options.push(option.id);
            totalCost += Number(option.price) || 0;
          }
        });

        if (addonObj.options.length > 0) {
          transformedData.push(addonObj);
        }
      });
    }

    return { addons: transformedData, cost: totalCost };
  };
  const selectAddon = (addon, option, price) => {
    let addonId = addon.id;
    let selectedAddonsList = [...selectedAddons];
    let found = false;

    selectedAddonsList?.forEach(item => {
      if (item.addonId === addonId) {
        found = true;
        if (!item.options.includes(option)) {
          if ((addon.selection_type == 1 && item.options.length > 0) || (addon.selection_type == 2 && Number(addon.max_select) > 0 && item.options.length >= Number(addon.max_select))) {

            toast("You have already selected max addons for this category", {
              position: "bottom-center", autoClose: 2000, hideProgressBar: true, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "light", className: 'text-danger toast-style-1'
            });
          } else {
            item.options.push(option);
            setProductCost(Number(productCost) + Number(price));
            setAddonsCost(Number(addonsCost) + Number(price));
            // setProductPrice(productCost)
          }
        } else {
          item.options = item.options.filter((opt) => opt !== option);

          setProductCost(Number(productCost) - Number(price));
          setAddonsCost(Number(addonsCost) - Number(price));

        }
      }
    });

    if (!found) {
      selectedAddonsList.push({ "addonId": addonId, "options": [option] });
      setProductCost(Number(productCost) + Number(price));
      setAddonsCost(Number(addonsCost) + Number(price));
    };
    setSelectedAddons(selectedAddonsList);
  }

  const checkIsSelectedAddon = (addonId, option) => {
    let selectedAddonsList = [...selectedAddons];
    let found = false;
    selectedAddonsList.forEach(item => {
      if (item.addonId === addonId) {
        if (item.options.includes(option)) {
          found = true;
        }
      }
    });

    return found;
  }

  const checkButtonStatus = () => {

    for (const addon of (product?.addons || [])) {
      const selectedAddon = selectedAddons?.find((sel) => sel?.addonId == addon.id);


      const selectedOptionsCount = selectedAddon ? selectedAddon?.options?.length : 0;

      if (addon?.required == 1 && addon?.selection_type == 2 && selectedOptionsCount < Math.max(1, Number(addon?.min_select) || 0)) {
        toast(`You need to select at least ${Math.max(1, Number(addon?.min_select) || 0)} option(s) from the category ${addon?.addon_name}`, {
          position: "bottom-center", autoClose: 2000, hideProgressBar: true, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "light", className: 'text-danger toast-style-1 toast-custom-style' // Add your custom class here
        });
        return;
      } else if (addon?.required == 1 && addon?.selection_type == 1 && selectedOptionsCount <= 0) {

        toast(`You need to select at least 1 option(s) from the category ${addon.addon_name}`,
          { position: "bottom-center", autoClose: 2000, hideProgressBar: true, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "light", className: 'text-danger toast-style-1 toast-custom-style' });

        return;
      }
    }

    closeAddonModal()
    Add_Remove_productcount(productid, "add",);
  }

  const openEditAddonModal = (addons, addedAddons, productid, added_count) => {
    let transformedData = transformDataAndCalculateTotalCost(addons, addedAddons);
    setSelectedAddons(transformedData.addons);
    setProduct_Id(productid);
    setProductCount(added_count)
    addonEditeModalRef.current.classList.add("show");
    addonEditeModalRef.current.style.display = "block";
    setAddonModel(true)
  };
  const closeEditAddonModal = () => {
    addonEditeModalRef.current.classList.remove("show");
    addonEditeModalRef.current.style.display = "none";
    // setModelOpen(true)
  };

  const update_Product = async (productId, Operation, count) => {
    try {
      // if (addonstate != "0") {
      let addons = [];
      selectedAddons?.map((addon) => {
        addons = [...addons, ...addon.options];
        // setReqAddon(addons)
      });
      // }
      let reqData = {
        vendor_id: vendorId,
        product_id: productId,
        shipping_type: shipingtype,
        quantity: count,
        operation: Operation,
        cart_id: cartId,
        card_status: cardStatus,
        card_type: cardType,
        card_id: cardId,
        addons: addons
      };

      let res = await addOrRemoveProductCart(reqData);
      if (res.status == 200) {
        const cartItemsFromAPI = res?.data?.cart_items || [];

        const updatedCartItems = cartItemsFromAPI.map(item => ({
          ...item,
          price: productCost,
        }));
        const cart_items = {
          cart_items: updatedCartItems,
          cart_id: res?.data?.cart_id,
          cart_count: updatedCartItems.length,
          sub_total: res?.data?.sub_total,
        };
        localStorage.setItem("cart_items", JSON.stringify(cart_items));
        getproductdetails();
        setSelectedAddons([]);
        closeEditAddonModal()
      }
    } catch (err) {
      if (err.response?.status == 400 || err.response?.status == 500) {
        showToast(err.response.data.message || "Something went wrong. Please try again.");
      } else {
        showToast(`You can't add more than ${productCount} of this product`)
      }
    }
    //  catch (error) {
    //     if (err.response.status == 400 || err.response.status == 500) {
    //         toast(err.response.data.message, { position: "bottom-center", autoClose: 2000, hideProgressBar: true, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "light", className: "text-danger toast-style-1", });
    //       }
    //   toast(`You can't add more than ${productCount} of this product`, { position: "bottom-center", autoClose: 2000, hideProgressBar: true, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "light", className: "text-danger toast-style-1", });
    // }
  };
  const confirmUpdate = () => {
    let ProductItem = product?.result
    var ProductHave = ProductItem?.some((obj) => obj.product_id == productid);
    ProductItem?.map((Cartdata, id) => {

      if (Cartdata.product_id == productid) {
        if (Cartdata.quantity > productCount) {
          update_Product(productid, 'remove', Cartdata.added_count - productCount);
          setAddonModel(false)
        } else if (productCount > Cartdata.added_count) {
          update_Product(productid, 'add', productCount - Cartdata.added_count);
          setAddonModel(false)
        } else {
          setAddonModel(false)
          closeEditAddonModal()
        }
      }
    })

  }

  return (
    <>
      {
        pageLoaded ?
          <div className="">
            <div>
              <div className="d-flex justify-content-between align-items-center p-3 p-navbar bg-white">
                <div className="d-flex justify-content-between align-items-center ms-2 me-2">
                  <img src={p_nav_previous} width={"24px"} height={"16px"} alt="Previous Button" role="button" onClick={() => navigate(-1)} />
                  <div className="ff-balooPaaji2-bold fs-20 ms-2 ps-1">Product details</div>
                </div>
                {
                  orderType != "booknow" || flow != 'LoyaltyProduct' ?
                    <>{
                      cartCount > 0 ? (
                        <div onClick={() => navigate("/productBasket", { state: { merchantId: vendorId, cartId, flow: flow } })} style={{ cursor: "pointer" }} >
                          <img src={ion_cart_outline} />
                          <div className="basketCount">
                            {cartCount > 0 ? (
                              <span style={{
                                height: "20px", width: "20px", backgroundColor: "var(--primary-bg)", color: "white", borderRadius: "50%",
                                display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center",
                              }} >
                                {cartCount}
                              </span>
                            ) : (cartCount > 0 && <span>{cartCount}</span>)}
                          </div>
                        </div>
                      ) : (
                        <div>
                          <img src={ion_cart_outline} />
                        </div>
                      )}
                    </>
                    : ""
                }



              </div>

              <div className="scroller-style-y">
                {product?.imges?.length !== 0 && (
                  <div id="carouselExampleInterval" className="carousel slide " data-bs-ride="carousel" data-bs-interval="2000"  >
                    <div className="carousel-inner">
                      {product?.imges?.map((item, index) => (
                        <div key={index} className={`carousel-item ${index === 0 ? "active" : ""}`}   >
                          <img src={item.image == "" ? defaultimg : item.image_url} className="d-block w-100 curve" alt={`slide-${index}`} />
                        </div>
                      ))}
                    </div>
                    <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleInterval" data-bs-slide="prev"  ></button>
                    <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleInterval" data-bs-slide="next"  ></button>
                  </div>
                )}



                {/* New Addon Modal Starts*/}

                <div className="offcanvas addOnModalOffcancas" tabIndex="-1" ref={addonModalRef} >
                  <div className=" d-flex justify-content-end mt-1" onClick={() => { closeAddonModal(); setSelectedAddons([]) }}>
                    <div className="fs-20 ff-poppins-semiBold me-2 crossContainer" ><CgClose /> </div>
                  </div>

                  <div className="insideAddon  " >
                    <div className="addonContainer addOnModel_scroll">
                      {
                        product_Id == product?.product_id ?
                          product?.addons.map((addon, addonIndex) => {
                            return (
                              <div className="AddonCategoryCont" key={addonIndex} >
                                <div className="addonCatgoryContTop">
                                  <div className="addonCategoryTitle">Choose {addon?.addon_name}</div>
                                  <div className="addonCategorySubtitle">Select any (Optional)</div>
                                </div>
                                <div className="addonProductListCont">
                                  {addon?.options.map((option, optionIndex) => (
                                    <div className="addonProductCont" key={optionIndex}>
                                      <div className="addonProductLeft">
                                        {(option?.type == "1" || option?.type == "2") && (
                                          <img
                                            src={option?.type == "1" ? vegIcon : nonvegIcon}
                                            height="13px"
                                            width="13px"
                                          />
                                        )}
                                        <div className="addonProductName">
                                          {option?.name}
                                        </div>
                                      </div>
                                      <div className="addonProductRight">
                                        <div className="addonPrice">+ <span className="rupeeIcon">₹</span>{option?.price}</div>
                                        {checkIsSelectedAddon(addon.id, option.id) ? (
                                          <div onClick={() => {
                                            selectAddon(addon, option.id, option?.price);
                                            setProduct_Id(product?.product_id);
                                          }}
                                            className="checkBoxContainer"  >
                                            <FaSquareCheck size={18} />
                                          </div>
                                        ) : (
                                          <div onClick={() => {
                                            selectAddon(addon, option.id, option?.price);
                                            setProduct_Id(product?.product_id);
                                          }}
                                            className="checkBoxContainer"  >
                                            <FaRegSquare size={18} />
                                          </div>
                                        )
                                        }
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>

                            )
                          }) : ""}
                    </div>


                    <div style={{ backgroundColor: '#fff', position: "sticky", bottom: 0, width: '100%' }}>
                      <div className=" p-1  ">
                        <p className="m-0 d-flex justify-content-end primary-text ff-poppins-regular fs-14 mb-1 me-3">
                          Cost :&nbsp;<span className="rupeeIcon "> ₹</span>{productCost} </p>
                        <button type="button" className="btn-type-1 ff-poppins-semiBold fs-14 w-100 primary-bg border-0 text-white justify-content-center d-flex align-items-center"
                          onClick={() => checkButtonStatus()} >
                          Confirm
                        </button>
                      </div>

                    </div>

                  </div>

                </div>



                <div className="" style={{ marginBottom: 100 }}>
                  <div className="p-3">
                    <div>
                      {product?.food_type && (
                        <img src={product?.food_type == "1" ? vegIcon : product?.food_type == "2" ? nonvegIcon : ""} className="food-type-icon" />
                      )}
                      <span className="ms-2 fs-13 ff-poppins-medium">{product?.food_type == "1" ? 'Veg' : 'Non-Veg'}</span>
                    </div>
                    <div className="ff-poppins-semiBold fs-16 "> {product.product_name} </div>
                    <div className="d-flex  fs-12 ff-poppins-medium">
                      <div className="d-flex ff-poppins-semiBold" >
                        <span className="rupeeIcon ">₹</span>{product.price}
                      </div>
                      <span className="primary-text"> {product.benefit ? ('(' + product.benefit_lable + ')') : ''} </span>
                    </div>
                    <div className="ff-poppins-semiBold primary-text fs-12">
                      {product.unit_quantity} {product.unit_type_name}
                      {
                        product?.stock_status == 1 ?
                          <p className="primary-text m-0 ff-poppins-regular fs-12">{product.stock_quantity} {" "} Left</p>
                          : ""
                      }
                    </div>
                  </div>


                  <div>
                    <p className="ff-poppins-regular secondary-text-1 fs-13 m-0 p-3">
                      {product.description}
                    </p>
                  </div>
                </div>


                {
                  showModel &&
                  <SelectShippingOffCanvas isOpen={showModel} toggleOffCanvas={toggleOffCanvas} forCart={vendorId} data={product} />
                }
              </div>
            </div>


            {
              orderType != "booknow" || flow != 'LoyaltyProduct' ?
                <>
                  {<div className="product-paybtn-container ">
                    <div className="offcanvas-body small">
                      {
                        product.added_count == 0 ?
                          <button className="my-2 py-3 addToBasketBtn primary-bg text-white ff-poppins-semiBold rounded-2 border-0 py-2"
                            onClick={() => flow == 'ProductSearch' ? setShowModel(true) : product?.addons == "" ? Add_Remove_productcount(productid, "add") : openAddonModal()} >
                            Add to Basket
                          </button> :
                          <button className="my-2 py-3 addToBasketBtn primary-bg text-white ff-poppins-semiBold rounded-2 border-0 py-2"
                            onClick={() => navigate("/productBasket", { state: { merchantId: vendorId, cartId, flowtype: flowtypeValue } })}>
                            Go to Basket
                          </button>
                      }
                    </div>
                  </div>
                  }


                  {/* {product.added_count == 0 ? (
								<div className="addToBasketBtnDiv">
									<button className="my-2 py-3 addToBasketBtn primary-bg text-white ff-poppins-semiBold rounded-2 border-0 py-2"
										onClick={() => flow == 'ProductSearch' ? setShowModel(true) : product?.addons == "" ? Add_Remove_productcount(productid, "add") : openAddonModal()} >
										Add to Basket
									</button>
								</div>
								) : (
									<>

										<div className="addToBasketBtnDiv">
											<button className="my-2 py-3 addToBasketBtn primary-bg text-white ff-poppins-semiBold rounded-2 border-0 py-2"
												onClick={() => navigate("/productBasket", { state: { merchantId: vendorId, cartId, flowtype: flowtypeValue } })}>
												Go to Basket
											</button>
										</div>
									</>
								)
								} */}
                </>
                : ""

            }
            {isModalOpen && <div className="modal-backdrop fade show"></div>}

          </div >
          :
          <div className='d-flex justify-content-center  skeleton-bg'>
            <div >
              <Skeleton height={300} width={320} style={{ marginBottom: "20px", borderRadius: "12px" }} />
              <Skeleton height={60} width={320} style={{ borderRadius: "12px" }} />
              <Skeleton height={60} width={320} style={{ borderRadius: "12px" }} />
              <Skeleton height={90} width={320} style={{ borderRadius: "12px" }} />
              <Skeleton height={90} width={320} style={{ borderRadius: "12px" }} />
              <Skeleton height={90} width={320} style={{ borderRadius: "12px" }} />
              <Skeleton height={90} width={320} style={{ borderRadius: "12px" }} />
            </div>
          </div>

      }


    </>
  );
};

export default SingleProduct;
